import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.288 28.953a5 5 0 0 0 4.422 4.421c.419.046.849.09 1.29.13v3.45a3 3 0 0 0 5.103 2.139l5.224-5.135c.493.004.994.006 1.503.006 5.237 0 9.72-.2 13.45-.603a5 5 0 0 0 4.434-4.425C37.905 27.193 38 24.884 38 22c0-2.71-.084-5.078-.252-7.105a7 7 0 0 0-6.361-6.394A130.338 130.338 0 0 0 8.61 8.496a7 7 0 0 0-6.357 6.392C2.084 16.916 2 19.286 2 22c0 2.893.095 5.209.288 6.953ZM24.8 38H28c.575 0 1.143-.003 1.706-.008l5.191 5.1A3 3 0 0 0 40 40.954v-3.448c.442-.041.872-.085 1.29-.13a5 5 0 0 0 4.422-4.422C45.904 31.21 46 28.893 46 26c0-2.714-.084-5.084-.253-7.112a7.001 7.001 0 0 0-4.424-5.939 1 1 0 1 0-.729 1.863 5 5 0 0 1 3.16 4.242C43.918 21.022 44 23.338 44 26c0 2.826-.093 5.073-.276 6.734a3 3 0 0 1-2.653 2.652c-.684.076-1.403.145-2.154.207a1 1 0 0 0-.917.997v4.363a1 1 0 0 1-1.7.713l-5.488-5.392a1 1 0 0 0-.714-.287c-.69.009-1.39.013-2.098.013l-3.2-.001c-3.104-.002-4.307-.002-5.802.001a1 1 0 1 0 .004 2c1.492-.003 2.694-.003 5.797-.001Z",
      clipRule: "evenodd"
    }
  )
);
var SvgChatFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChatFilled_default = SvgChatFilled;

export { ChatFilled_default as default };
